import React, { useState } from 'react';
import ShareDialog from '.';

function useShareDialog() {
    const [open, setOpen] = useState(false);
    const [publisher, setPublisher] = useState(null);

    function openShareDialog(pub) {
        setPublisher(pub || null);
        setOpen(true);
    }

    function closeShareDialog() {
        setOpen(false);
        setPublisher(null);
    }

    function renderShareDialog() {
        return (
            <ShareDialog
                open={open}
                publisher={publisher}
                onClose={closeShareDialog}
            />
        );
    }

    return {
        openShareDialog,
        renderShareDialog,
    };
}

export default useShareDialog;
